<template>
    <div id="course-video">
        <Head></Head>
        <div class="video-head">
            <div class="head-container indent">
                <i class="icon iconfont icon-u-arrow3-right" @click="back"></i>
                <div class="head-title indent">{{sectionData.videoName}}</div>
            </div>
        </div>
        <div class="video-main indent">
            <!--视频播放区域-->
        </div>
        <div class="video-section">
            <ul v-for="chapter in datas" :key="datas.videoChapterId">
                <span class="white">{{chapter.chapterTitle}}</span>
                <li :class="sectionData.videoId==s.videoId?'hover':''" v-for="s in chapter.lstVideos" v-show="s.videoId!=''&&s.videoId!=undefined" @click="selecChapter(s)">
                    <i class="icon iconfont icon-bofang1 white"></i>
                    <div class="chapter-name white">{{s.videoName}}</div>
                    <div v-show="false" class="chapter-times white">(播放{{s.watchCount}}次)</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import Head from '@/components/Head'

export default {
    data(){
        return{
            datas:[],
            sectionData:{},
            player:{},
            confirmMsg:'当前课程需付费,是否付费购买？',
            maxVideoId:'1'
        }
    },
    methods:{
        back:function(){
            var resourceId=this.$route.query.resourceId;
            this.$router.push({path:'/lessonDetail',query:{resourceId:resourceId}});
        },
        selecChapter(data){
            var resourceId=this.$route.query.resourceId;
            var chapterId=data.videoId;
            this.$router.push({path:'lessonVideo',query:{resourceId:resourceId,videoId:chapterId}});
            this.confirmMsg='当前课程需付费,是否付费购买？';
            this.checkIsBug();
            
        },
        nextChapter(data){
            var resourceId=this.$route.query.resourceId;
            var chapterId=data.videoId;
            this.$router.push({path:'lessonVideo',query:{resourceId:resourceId,videoId:chapterId}});
            this.confirmMsg='下一节课程尚未付费，是否付费购买？';
            this.checkIsBug();
            
        },
        buyConfirm(){
            var data={
                videoId:this.$route.query.videoId
            };
            var that=this;
            that.$confirm(that.confirmMsg,'提示',{
                confirmButtonText: '购买',
                cancelButtonText: '放弃',
                type: 'warning'
            }).then(()=>{
                that.buyVideo(data);
            });
        },
        buyVideo(data){
            var that=this;
            var resourceId=this.$route.query.resourceId;
            var chapterId=data.videoId;
            var params =  this.$Qs.stringify({
                resourceId:resourceId,
                videoId:chapterId
            });
            that.$Axios.post('/Wisdom/shop/shopVideoScore.htm',params).then((res)=>{
                var data=res.data;
                that.sectionData={};
                if(data.code=='0'){
                    that.$message.success("恭喜您，购买成功！");
                    that.sectionData=data.data;
                    that.play(that.sectionData.videoLink);
                }else if(data.code=='-1'){//未登录
                    this.$confirm(data.desc, '提示', {
                        confirmButtonText: '前往登录',
                        cancelButtonText: '暂不登录',
                        type: 'warning'
                    }).then(()=>{
                        that.axiosSendUrl(window.location.href,"/Wisdom/user/logo.htm");
                    });
                }else if(data.code=='666666'){//积分不足
                    this.$confirm(data.desc, '提示', {
                        confirmButtonText: '前往充值',
                        cancelButtonText: '暂不充值',
                        type: 'warning'
                    }).then(()=>{
                        that.axiosSendUrl(window.location.href,"/Wisdom/jsp/pay2.jsp");
                    });
                }
                
            }).catch(function (error) {
                that.$message.error(error);
            });
        },
        getUrl(data){
            var that=this;
            var resourceId=this.$route.query.resourceId;
            var chapterId=data.videoId;
            var params =  this.$Qs.stringify({
                resourceId:resourceId,
                videoId:chapterId
            });
            that.$Axios.post('/Wisdom/shop/shopVideoScore.htm',params).then((res)=>{
                var data=res.data;
                that.sectionData={};
                if(data.code=='0'){
                    that.sectionData=data.data;
                    that.play(that.sectionData.videoLink);
                }else{
                    that.$message.error(data.data.desc);
                }
                
            }).catch(function (error) {
                that.$message.error(error);
            });
        },
        checkIsBug(){
            var that=this;
            var resourceId=this.$route.query.resourceId;
            var chapterId=this.$route.query.videoId;
            var params =  this.$Qs.stringify({
                resourceId:resourceId,
                videoId:chapterId
            });
            this.$Axios.post('/Wisdom/shop/hasShopVideo.htm',params).then((res)=>{
                var data=res.data;
                if(data.code=='-1'){//未登录
                    this.$confirm(data.desc, '提示', {
                        confirmButtonText: '前往登录',
                        cancelButtonText: '暂不登录',
                        type: 'warning'
                    }).then(()=>{
                        that.axiosSendUrl(window.location.href,"/Wisdom/user/logo.htm");
                    });
                }else if(data.code=='111111'){//未购买
                    that.buyConfirm();
                }else if(data.code=='0'){//已经购买
                    that.getUrl({
                        videoId:chapterId
                    });
                }
                
            }).catch(function (error) {
    　　        that.$message.error(error);
            });
        },
        playNext(){
            var videoId=Number(this.$route.query.videoId)+1;
            var data={
                videoId:videoId.toString()
            };
            if(Number(videoId)>=Number(this.maxVideoId)+1){
            }else{
                this.nextChapter(data);
            }
            
        },
        play(url){
            // 挂载完成后进行
            var videoObject = {
                        container: '.video-main', //容器的ID或className
                        variable: 'player', //播放函数名称
                        loaded: 'loadedHandler', //当播放器加载后执行的函数
                        loop: false, //播放结束是否循环播放
                        //cktrack: 'static/ckplayer/material/srt.srt', 字幕文件
                        poster: '../../static/video_loading.gif', //封面图片
                        /*preview: { //预览图片
                            file: ['static/ckplayer/material/mydream_en1800_1010_01.png', 'static/ckplayer/material/mydream_en1800_1010_02.png'],
                            scale: 2
                        },*/
                        config: '', //指定配置函数
                        debug: false, //是否开启调试模式
                        drag: 'start', //拖动的属性
                        seek: 0, //默认跳转的时间
                        autoplay: true, //是否自动播放
                        /*广告部分开始
                        adfront: 'http://www.ckplayer.com/yytf/swf/front001.swf,http://www.ckplayer.com/yytf/swf/front002.swf', //前置广告
                        adfronttime: '15,15',
                        adfrontlink: '',
                        adpause: 'http://www.ckplayer.com/yytf/swf/pause001.swf,http://www.ckplayer.com/yytf/swf/pause002.swf',
                        adpausetime: '5,5',
                        adpauselink: '',
                        adinsert: 'http://www.ckplayer.com/yytf/swf/insert001.swf,http://www.ckplayer.com/yytf/swf/insert002.swf',
                        adinserttime: '10,10',
                        adinsertlink: '',
                        inserttime: '10,80',
                        adend: 'http://www.ckplayer.com/yytf/swf/end001.swf,http://www.ckplayer.com/yytf/swf/end002.swf',
                        adendtime: '15,15',
                        adendlink: '',
                        //广告部分结束
                        promptSpot: [ //提示点
                            {
                                words: '提示点文字01',
                                time: 30
                            },
                            {
                                words: '提示点文字02',
                                time: 150
                            }
                        ],*/
                        video: [
                            [url, 'video/mp4', '中文标清', 0]
                        ]
                    };
            // 定义一个对象
            var player = new ckplayer(videoObject);
            this.player=player;
            var that=this;
            this.player.addListener('ended',this.playNext);
            player.videoPlay();
        },
        axiosSendUrl(url,redirectUrl){
            var params =  this.$Qs.stringify({
                urlPageLocation:url
            });
            this.$Axios.post('/Wisdom/user/getPageLocation.htm',params).then((res)=>{
                window.location.href=redirectUrl;
            }).catch(function(error){
                window.location.href=redirectUrl;
            });
        }
        
    },
    mounted(){
        var resourceId=this.$route.query.resourceId;
        var chapterId=this.$route.query.videoId;
         /**
         * 查询章节信息
         */
        var that=this;
        var params =  this.$Qs.stringify({
                resourceId:resourceId
            });
        this.$Axios.post('/Wisdom/video/lessonChapterVideos.htm',params).then((res)=>{
            var data=res.data;
            that.datas=data.data;
            that.datas.forEach((val,i)=> {
                val.lstVideos.forEach((v,j)=>{
                    if(v.videoId==chapterId){
                        that.sectionData=v;
                    }
                    if(Number(v.videoId)>Number(that.maxVideoId)){
                       that.maxVideoId=v.videoId;
                    }
                });
            });
        }).catch(function (error) {
　　        that.$message.error(error);
        });
        /**
         * 查询指定章节视频
         */
        that.checkIsBug();
    },
    components:{
        Head:Head
    }
}
</script>
<style scoped>
#course-video{
    width: 100%;
    height: 700px;
    background: rgba(0, 0, 0, 0.8);
}
.video-head{
    width: 100%;
    height: 60px;
    background:#fff;
    float: left;
}
.indent{
    margin-left: 40px;
}
.head-container{
    width: 100%;
    height: 100%;
}
.icon-u-arrow3-right{
    line-height: 60px;
    font-size: 30px;
    color: rgba(0, 0, 0, 0.5);
    float: left;
}
.icon-u-arrow3-right:hover{
    color: rgba(0, 0, 0, 0.3);
    cursor: pointer;
}
.head-title{
    line-height: 60px;
    float: left;
    font-size: 16px;
    font-weight: bold;
}
.video-main{
    width: 70%;
    height: 560px;
    background: #ccc;
    float: left;
    background-image: url('../../static/video_loading.gif');
    background-position: center;
}
.video-section{
    width: calc(30% - 40px);
    height: 560px;
    float: left;
    overflow-y: scroll;
}
.video-section ul{
    margin-left: 20px;
    list-style: none;
    float: left;
    width: 100%;
}
.video-section ul span{
    font-weight: bold;
}
.white{
    color: rgba(255, 255, 255, 0.6);
}
.video-section ul li{
    margin-left: 20px;
    height: 30px;
    line-height: 30px;
    width: 100%;
}
.video-section ul li:hover{
    background: #ccc;
    cursor: pointer;
}
.icon-bofang1{
    float: left;
}
.chapter-name{
    margin-left: 10px;
    float: left;
}
.chapter-times{
    margin-left: 10px;
    float: left;
}
.hover{
    background: #ccc;
    cursor: pointer; 
}
</style>



// WEBPACK FOOTER //
// src/components/CourseVideo.vue